import script from "./ConfirmacionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmacionModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmacionModal.vue?vue&type=style&index=0&id=277927c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-277927c8"]])

export default __exports__